export default function GlossaryDetailedScreenShader() {
    // Used in GlossaryDetailedScreenContent to shade
    // scrolled content when going up

    // BUILD
    return (
        <div className="sticky top-0 h-[12px] bg-gradient-to-b from-backgroundLight3 to-transparent pointer-events-none z-10"></div>
    );
}